import {
  EditOutlined,
  MobileOutlined,
  QuestionCircleOutlined
} from '@ant-design/icons';
import { Button, Card, Form, Input, Spin, Tooltip, message } from 'antd';
import * as moment from 'moment';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import CustomDatePicker from '../../components/CustomDatePicker';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import UserContext from '../../context/user-context';
import { errorHandler, gruposSistema } from '../../utils';
import { instanceRef } from '../../utils/axios';

const formItemLayout = {
  labelCol: {
    xs: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 }
  }
};

const UsuarioView = ({ history, match }) => {
  const { id } = useParams();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [loadingCodigo, setLoadingCodigo] = useState();
  const [tieneApp, setTieneApp] = useState();
  const [usuario, setUsuario] = useState();
  const { user } = useContext(UserContext);
  const [sucursal, setSucursal] = useState(false);

  const consultarTieneApp = useCallback(async () => {
    try {
      await instanceRef.instance.get(`/usuarios/${match.params.id}/tiene-app`);
      setTieneApp(true);
    } catch (error) {
      setLoading(false);
    }
  }, [match.params.id]);

  useEffect(() => {
    const loadUser = async () => {
      try {
        const response = await instanceRef.instance.get(`/auth/users/${id}`);
        if (response.data?.data) {
          const grupo = response.data?.data.grupo;
          setUsuario({
            ...response.data?.data,
            fecha_nacimiento: moment(
              response.data?.data.fecha_nacimiento,
              'YYYY-MM-DD'
            ),
            grupo: getDescripcionGrupo(grupo)
          });

          if (grupo) {
            if (['ADMIN_SUCURSAL', 'EJECUTIVO'].includes(grupo)) {
              setSucursal(true);
            }
          }
        }
      } catch (error) {
        errorHandler(error);
      }
      setLoading(false);
    };
    if (id && form) {
      loadUser();
      consultarTieneApp();
    }
  }, [id, form, consultarTieneApp]);

  useEffect(() => {
    form.resetFields();
  }, [usuario, form]);

  const getDescripcionGrupo = (grupo) => {
    if (grupo) {
      return gruposSistema[grupo];
    }
    return '';
  };

  return (
    <ResponsiveContainer size="large">
      <Card
        title="Datos del Usuario"
        style={{ textAlign: 'left' }}
        extra={
          user &&
          !(
            user['cognito:groups'][0] === 'ADMIN_SUCURSAL' &&
            usuario.grupo === 'ADMIN_SUCURSAL'
          ) && (
            <Tooltip title="Editar usuario">
              <Button
                type="text"
                icon={<EditOutlined />}
                size="middle"
                onClick={() => history.push(`edit/${usuario.id}`)}
              />
            </Tooltip>
          )
        }
      >
        <Spin spinning={loading} delay={500} size="large" tip="Cargando...">
          <div style={{ maxWidth: '500px' }}>
            {tieneApp && (
              <div style={{ paddingBottom: 16 }}>
                <Button
                  type="link"
                  icon={<MobileOutlined />}
                  loading={loadingCodigo}
                  onClick={async () => {
                    try {
                      setLoadingCodigo(true);
                      const response = await instanceRef.instance.post(
                        `usuarios/${match.params.id}/codigo`
                      );
                      setLoadingCodigo(false);
                      if (response.data.data) {
                        const { correo } = response.data.data;
                        message.success(
                          `Se envió un código de acceso a ${correo}`
                        );
                      } else {
                        message.warning('Error al generar el código de acceso');
                        return;
                      }
                    } catch (err) {
                      setLoadingCodigo(false);
                      errorHandler(err);
                    }
                  }}
                >
                  Generar Código para app
                </Button>
              </div>
            )}
            <Form
              {...formItemLayout}
              initialValues={usuario}
              scrollToFirstError
              form={form}
              name="usuario"
              autoComplete="off"
              layout="vertical"
            >
              <Form.Item label="Correo" name="correo">
                <Input placeholder="Correo" disabled />
              </Form.Item>
              <Form.Item
                label="Nombre de Usuario para Acceso al Sistema"
                name="usuario"
              >
                <Input placeholder="Nombre de usuario" disabled />
              </Form.Item>
              <Form.Item
                label={
                  <span>
                    Nombre y apellido&nbsp;
                    <Tooltip title="Nombre a mostrar">
                      <QuestionCircleOutlined />
                    </Tooltip>
                  </span>
                }
                name="nombres"
              >
                <Input disabled />
              </Form.Item>
              <Form.Item
                label={
                  <span>
                    Nombre/Código Interno de Usuario&nbsp;
                    <Tooltip title="Nombre de usuario alternativo">
                      <QuestionCircleOutlined />
                    </Tooltip>
                  </span>
                }
                name="usuario_interno"
              >
                <Input disabled />
              </Form.Item>
              <Form.Item label="Cédula de identidad" name="cedula">
                <Input disabled />
              </Form.Item>
              <Form.Item label="Fecha de Nacimiento" name="fecha_nacimiento">
                <CustomDatePicker
                  style={{ width: '100%' }}
                  placeholder="DD/MM/YYYY"
                  format="DD/MM/YYYY"
                  disabled
                  allowClear={false}
                  open={false}
                />
              </Form.Item>

              <Form.Item label="Dirección" name="domicilio">
                <Input disabled />
              </Form.Item>
              <Form.Item label="Celular" name="celular">
                <Input disabled />
              </Form.Item>
              <Form.Item label="Rol" name="grupo">
                <Input disabled />
              </Form.Item>

              {sucursal && (
                <Form.Item label="Sucursal" name={['sucursal', 'descripcion']}>
                  <Input disabled />
                </Form.Item>
              )}
            </Form>
          </div>
        </Spin>
      </Card>
    </ResponsiveContainer>
  );
};

export default UsuarioView;
